import { useState } from "react";
import { Link } from "react-router-dom";

const TruncatedText = ({ text , newsUrl}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="line-clamp-container">
      <p className={`line-clamp ${isExpanded ? "expanded" : ""}`}>
        {isExpanded ? text : `${text.slice(0, 460)}...`}
        {!isExpanded && text.length > 460 && (
          <span className="read-more" onClick={() => setIsExpanded(true)}>
            <Link
          to={newsUrl || "#"}
          target="_blank"
          rel="noopener noreferrer"
          className="read-more-link"
      >
          Read More
      </Link></span>
        )}
      </p>
    </div>
  );
};

export default TruncatedText;
